// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label.radio[data-v-cedd1bd2]:not(:last-child) {\n  margin-right: 1.5rem;\n}\n.cursor-pointer[data-v-cedd1bd2] {\n  cursor: pointer;\n}\n.cursor-not-allowed[data-v-cedd1bd2] {\n  cursor: not-allowed;\n}\n.is-disabled[data-v-cedd1bd2] {\n  color: #666666;\n  cursor: not-allowed;\n}", ""]);
// Exports
module.exports = exports;
